import React, { useEffect } from 'react'
import Slider from 'react-slick'
import rightArrow from "../../../assets/images/slider/right-arrow.png"
import RegOpenAccountFormEquitas from '../regOpenAccountFormEquitas'

function CustomLeftArrow(props) {
    const { className, style, onClick } = props;
    return (
        <img
            src={rightArrow}
            className={className}
            onClick={onClick}
            height={18}
            width={18}
            style={{
                transform: 'rotate(180deg)', // Rotate the image 180 degrees
                cursor: 'pointer'            // Change cursor to pointer on hover
            }}
        />
    );
}

function CustomRightArrow(props) {
    const { className, style, onClick } = props;
    return (
        <img
            src={rightArrow}
            className={className}
            onClick={onClick}
            alt="Right Arrow"
            height={18}
            width={18}
        />
    );
}


const EquitasLandingSection = () => {


    useEffect(() => {
        // Get all the accordion buttons
        const accordionButtons = document.querySelectorAll('.accordion-button');

        // Function to handle the click event
        const handleAccordionClick = (button) => {
            return () => {
                // Close all panels except the one clicked
                accordionButtons.forEach((btn) => {
                    if (btn !== button) {
                        btn.classList.remove('active');
                        btn.nextElementSibling.style.display = 'none';
                        btn.nextElementSibling.style.maxHeight = null;
                    }
                });

                // Toggle the active className to highlight the active button
                button.classList.toggle('active');

                // Toggle the visibility and max height of the panel
                const panel = button.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                    panel.style.display = 'none';
                } else {
                    panel.style.maxHeight = `${panel.scrollHeight + 74}px`;
                    panel.style.display = 'block';
                }
            };
        };

        // Add click event listeners to each accordion button
        accordionButtons.forEach((button, index) => {
            button.addEventListener('click', handleAccordionClick(button));

            // Open the first panel by default
            if (index === 0) {
                button.classList.add('active');
                button.nextElementSibling.style.maxHeight = `${button.nextElementSibling.scrollHeight + 74}px`;
                button.nextElementSibling.style.display = 'block';
            } else {
                button.nextElementSibling.style.display = 'none';
            }
        });

        // Cleanup event listeners on component unmount
        return () => {
            accordionButtons.forEach((button) => {
                button.removeEventListener('click', handleAccordionClick(button));
            });
        };
    }, []);

    const settings = {
        infinite: true,
        slidesToShow: 1,
        dots: false,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        nextArrow: <CustomRightArrow />,
        prevArrow: <CustomLeftArrow />,
        responsive: [
            {
                breakpoint: 1024, // 1024px or larger
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 768, // 768px or larger
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480, // 480px or larger
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    arrows: false,
                    dots: false
                }
            }
        ]
    };



    return (
        <>
            {/* Banner section starts here */}
            <section id="banner">
                <RegOpenAccountFormEquitas />
            </section>
            {/* Intro sections starts here */}
            <section id="intro" className="clearfix">
                <div className="bglightgray">
                    <div className="container ptb40">
                        <div className="dflex justify-content-center">
                            <div className="">
                                <h3
                                    className="font-poppins fw500 fsize36 fsize20 text-center text-blue equi-faq"
                                >
                                    Why Equitas small finance bank 3-in-1 account
                                </h3>
                            </div>
                        </div>
                        <h3 className="font-poppins fw300 fsize16 text-center text-blue">
                            <div className="spacer-15">
                                Its easy, efficient, and everything you need - all in one place
                            </div>
                        </h3>
                        <div className="spacer-30"></div>
                        {/* new slider code carousel commented for now*/}
                        {/* <div id="owl-carousel" >
                            <Slider {...settings} className="owl-carousel container slider-container-equitas">

                                <div className="item bgblue">
                                    <div className="dflex text-white align-items-center justify-content-center">
                                        <h5 className="fsize84 font-poppins fw500 zero">0</h5>
                                        <p className="fsize16 fsize11 font-poppins fw500 plr10">
                                            Zero charges <br />
                                            on online account opening
                                        </p>
                                    </div>
                                </div>
                                <div className="item bgblue">
                                    <div className="dflex text-white align-items-center justify-content-center">
                                        <h5 className="fsize84 font-poppins fw500 zero">0</h5>
                                        <p className="fsize16 fsize11 font-poppins fw500 plr10">
                                            Zero charges <br />
                                            on online account opening
                                        </p>
                                    </div>
                                </div>
                                <div className="item bgblue">
                                    <div className="dflex text-white align-items-center justify-content-center">
                                        <h5 className="fsize84 font-poppins fw500 zero">0</h5>
                                        <p className="fsize16 fsize11 font-poppins fw500 plr10">
                                            Zero charges <br />
                                            on online account opening
                                        </p>
                                    </div>
                                </div>
                                <div className="item bgblue">
                                    <div className="dflex text-white align-items-center justify-content-center">
                                        <h5 className="fsize84 font-poppins fw500 zero">0</h5>
                                        <p className="fsize16 fsize11 font-poppins fw500 plr10">
                                            Zero charges <br />
                                            on online account opening
                                        </p>
                                    </div>
                                </div>
                                <div className="item bgblue">
                                    <div className="dflex text-white align-items-center justify-content-center">
                                        <h5 className="fsize84 font-poppins fw500 zero">0</h5>
                                        <p className="fsize16 fsize11 font-poppins fw500 plr10">
                                            Zero charges <br />
                                            on online account opening
                                        </p>
                                    </div>
                                </div>
                                <div className="item bgblue">
                                    <div className="dflex text-white align-items-center justify-content-center">
                                        <h5 className="fsize84 font-poppins fw500 zero">0</h5>
                                        <p className="fsize16 fsize11 font-poppins fw500 plr10">
                                            Zero charges <br />
                                            on online account opening
                                        </p>
                                    </div>
                                </div>

                            </Slider>
                        </div> */}
                        <div className='dflex justify-content-center'>
                        <div className="bgblue equitas-card">
                            <div className="dflex text-white align-items-center justify-content-center">
                                <h5 className="fsize84 font-poppins fw500 zero">0</h5>
                                <p className="fsize16 fsize11 font-poppins fw500 plr10">
                                    Zero charges <br />
                                    on online account opening
                                </p>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                {/* <RegOpenAccountFormIdfc /> */}
            </section>
            {/* Footer section starts here */}
            <footer id="carousel" className="footer bgdarkgray">
                <div className="container">
                    <div className="text-center font-poppins fsize14 fsize11">
                        Disclaimer: 3 in 1 account is a joint offering of Saving account with
                        Equitas Small Finance Bank and Trading account with Motilal Oswal
                    </div>
                </div>
            </footer>

        </>
    )
}

export default EquitasLandingSection;
